import React from 'react'
import { MenuItem, Paper, Select, Typography } from '@mui/material'

interface GWSelectProps {
  gws: number[]
  selectedGW: string
  setSelectedGW: (gw: string) => void
  isMobile: boolean
}

const GWSelect: React.FC<GWSelectProps> = ({ gws, selectedGW, setSelectedGW, isMobile }) => {
  return (
    <Paper sx={{ p: { xs: 1.5, sm: 2 }, mb: 2 }}>
      <Typography
        variant='subtitle1'
        fontFamily='PremierLeagueBold'
        sx={{ fontSize: { xs: '0.875rem', sm: '1rem' }, mb: 1 }}
      >
        GW
      </Typography>
      <Select
        value={selectedGW}
        onChange={e => setSelectedGW(e.target.value)}
        fullWidth
        size={isMobile ? 'small' : 'medium'}
      >
        {gws.map(gw => (
          <MenuItem key={gw} value={gw.toString()}>
            <Typography
              fontFamily='PremierLeagueRegular'
              sx={{ fontSize: { xs: '0.75rem', sm: '0.875rem' } }}
            >
              {gw}
            </Typography>
          </MenuItem>
        ))}
      </Select>
    </Paper>
  )
}

export default GWSelect
